const graphOptions = [
  'geo',
  'bubbles',
  'pie',
  'hierarchical_donut',
  'lines',
  'array',
  'timeline',
  'histogram',
  'treemap',
  'word_cloud',
  'key_number_extended',
  'key_number',
  'boxplot',
];

export default graphOptions;
